import '@tarojs/plugin-platform-weapp/dist/runtime'

import { createReactApp, window } from '@tarojs/runtime'
import { initPxTransform } from '@tarojs/taro'
import component from "../node_modules/babel-loader/lib/index.js!./app.tsx"

import * as React from 'react'
import ReactDOM from 'react-dom'

var config = {"pages":["pages/virtual-list-demo/index"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"WeChat","navigationBarTextStyle":"black"}};
window.__taroAppConfig = config
var inst = App(createReactApp(component, React, ReactDOM, config))

initPxTransform({
  designWidth: 750,
  deviceRatio: {"640":1.17,"750":1,"828":0.905}
})
